<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-blue">
        <router-link :to="{ name: 'Start'}" tag="a" class="navbar-brand">
            <img class="d-none d-lg-block" src="../assets/logotipo.png" height="50" alt="">
            <img class="d-lg-none" src="../assets/logotipo.png" height="30" alt="">

        </router-link>
        <span class="navbar-text">
            <div class="d-lg-none"><b>AUTOFACTURACI&Oacute;N</b></div>
        </span>
        <button class="navbar-toggler" type="button" :class="{ collapsed : collapse }" @click="collapseMenu">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" :class="{ show : collapse }">
            <ul class="navbar-nav mx-auto">
                <li class="nav-item h2 text-white d-none d-lg-block">SAIT AUTOFACTURADOR</li>
            </ul>
            <ul class="navbar-nav pull-right">
                <li class="nav-item">
                    <router-link :to="{ name: 'Start'}" tag="a" class="nav-link">
                        <b>INICIO</b>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'Invoice'}" tag="a" class="nav-link">
                        <b>FACTURAR</b>
                    </router-link>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
    export default {
        name: 'Navbar',
        data() {
            return {
                expanded: false,
                collapse: false,
            }
        },
        methods: {
            collapseMenu() {
                this.collapse = !this.collapse;
            },
        }
    }
</script>
<style>
    /*.navbar-dark .navbar-nav .nav-link:hover,*/
    /*.navbar-dark .navbar-nav .nav-link:focus {*/
        /*color: #cc6300 !important;*/
    /*}*/
</style>

